import { getServerEnv } from './env-helper';

export const ProdStaticPath = 'https://flipsterstatic.com';
export const DevStaticPath = 'https://static-stg.prex.run';
export const StaticPath = getServerEnv() === 'prod' ? ProdStaticPath : DevStaticPath;

export const AppStoreUrl = 'https://apps.apple.com/app/flipster-trade-btc-crypto/id1660635220';
export const PlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.prestolabs.android.prex';
export const FlipsterApkUrl = `${StaticPath}/apk/flipster.apk`;

export const generateLinkWithQueryParams = (url: string, queryParams?: Record<string, string> | URLSearchParams) => {
  if (!queryParams) return url;
  if (!URL.canParse(url)) return url;

  const urlObj = new URL(url);
  const searchParamsObj = queryParams instanceof URLSearchParams ? queryParams : new URLSearchParams(queryParams);
  for (const [key, value] of searchParamsObj.entries()) {
    urlObj.searchParams.append(key, value);
  }
  return urlObj.toString();
};

export const generateWebviewUrl = (pathname: string) => {
  const url = new URL(window.location.href);
  url.pathname = pathname;

  if (url.hostname.startsWith('app')) return url.toString();

  // 호스트네임 초기 설정
  if (url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname.endsWith('.localhost')) {
    // 로컬 호스트 처리: staging 환경으로 연결
    url.hostname = 'app.stg.prex.run';
    url.port = ''; // 포트 번호를 제거
  } else if (url.hostname.includes('yoda.mobi')) {
    // ns 환경 처리: app- 접두사 추가
    url.hostname = `app-${url.hostname}`;
  } else {
    // 일반 환경 처리: app. 서브도메인 추가
    url.hostname = `app.${url.hostname}`;
  }

  return url.toString();
};
